import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ImgSrcContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
`;

export const CropperContainer = styled.div`
  position: relative;
  width: 100%;
  height: 300px;
`;

export const AspectsContainer = styled.div`
  display: inline-flex;
  justify-content: center;
  gap: 15px;
`;

export const Slider = styled.div`
  display: grid;
  grid-template-columns: 1fr 8fr 1fr;
  width: 100%;
  grid-gap: 10px;
  align-items: center;

  svg {
    justify-self: center;
  }
`;

export const ButtonsContainer = styled.div`
  display: inline-flex;
  justify-content: space-between;
  gap: 20px;
`;
